import { gql } from "@apollo/client";
import { Area } from "react-easy-crop";

export const MAX_FILE_SIZE = 10_485_760; // 10 MiB = 10 * 1024 * 1024 bytes
export const VALID_IMAGE_TYPES = ["image/jpeg", "image/jpg", "image/png"];

export interface ImageUploadProps {
  accountId: number;
  openModal: boolean;
  handleClose: () => void;
  handleSubmit: () => Promise<void>;
}

export interface ImageCropperProps {
  uploadedImage: string;
  setImageProperties: React.Dispatch<React.SetStateAction<ImageProperties>>;
}

export interface ImageProperties {
  zoom: number;
  rotation: number;
  croppedAreaPixels: Area;
}

export interface UploadProfilePhotoSignedUrlResponse {
  uploadProfilePhotoSignedUrl: string;
}

export const UPLOAD_PROFILE_PHOTO_SIGNED_URL_QUERY = gql`
  query uploadProfilePhotoSignedUrl($accountId: Int!) {
    uploadProfilePhotoSignedUrl(accountId: $accountId)
  }
`;
